import { Link } from "react-router-dom";
import { ArrowLeft, ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/common/Logo";
import { Card, CardContent } from "@/components/ui/card";
import { env } from "@/lib/env";
import { useTranslation } from "react-i18next";

interface Props {
  title: string;
  children: React.ReactNode;
}

export function LegalShell({ title, children }: Props) {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col safe-top safe-bottom">
      <header className="border-b sticky top-0 bg-background/95 backdrop-blur z-10">
        <div className="container max-w-3xl flex items-center gap-3 py-3">
          <Button asChild variant="ghost" size="icon"><Link to="/profile"><ArrowLeft /></Link></Button>
          <Logo showWord={false} />
          <h1 className="font-display text-lg font-bold">{title}</h1>
        </div>
      </header>

      <main className="container max-w-3xl py-6 flex-1 space-y-4">
        <Card className="border-warning/40 bg-warning/5">
          <CardContent className="py-3 flex items-center gap-3">
            <ShieldAlert className="size-5 text-warning" />
            <p className="text-sm">{t("legal.ageRestriction")}</p>
          </CardContent>
        </Card>

        <article className="prose prose-sm dark:prose-invert max-w-none space-y-4 [&_h2]:font-bold [&_h2]:text-lg [&_h2]:mt-6 [&_h3]:font-semibold [&_p]:text-muted-foreground [&_li]:text-muted-foreground">
          {children}
        </article>

        <Card>
          <CardContent className="py-3 text-center">
            <p className="text-sm">{t("legal.support", { email: env.VITE_SUPPORT_EMAIL })}</p>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
